import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Store from "../store";

import Pages from "../pages";
import Default from "../layouts/Default";

class VueRouterEx extends VueRouter {
  constructor(options) {
    super(options);
    this.routes = [];
    const { addRoutes } = this.matcher;
    const { routes } = options;
    this.routes = routes;
    this.matcher.addRoutes = newRoutes => {
      this.routes.push(...newRoutes);
      addRoutes(newRoutes);
    };
  }
}

Vue.use(VueRouterEx);

const router = new VueRouterEx({
  mode: "history",
  base: process.env.BASE_URL,
  routes: []
});

router.beforeEach((to, from, next) => {
  var isAuthenticated = Vue.$cookies.get("authenticated") == "true";
  let loginRoute = {
    name: "Login",
    path: "/",
    component: Pages["Login"],
    meta: {
      requiresAuth: false
    }
  };
  let l = router.resolve({ name: loginRoute.name });
  if (l.resolved.matched.length == 0) {
    router.addRoutes([loginRoute]);
  }
  var routes = Store.getters["allowedRoutes"];
  for (const route of routes) {
    let l = router.resolve({ name: route.name });
    if (l.resolved.matched.length == 0) {
      router.addRoutes([
        {
          name: route.name,
          path: route.path,
          component: Pages[route.component],
          meta: { layout: Default, requiresAuth: true }
        }
      ]);
    }
  }
  console.log("Intented To Route - Name : " + to.name + " Path : " + to.path);
  if (to.name == null) {
    let route = router.routes.find(x => x.path == to.path);
    if (route) {
      console.log("Routing Next - Name : " + route.name);
      next({ name: route.name, query: to.query, params: to.params });
      return;
    }
    console.log("Routing Not Available - Routing To Name : " + loginRoute.name);
    next({ name: loginRoute.name });
    return;
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (isAuthenticated) {
        console.log("Routing Authenticated - Name : " + to.name);
        next();
        return;
      }
      console.log("Routing Not Authenticated - Name : " + loginRoute.name);
      next({ name: loginRoute.name });
      return;
    }
    console.log("Routing Now To Name : " + to.name);
    next();
    return;
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js